import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {forkJoin} from 'rxjs';
import {map, retry} from 'rxjs/operators';
import {LabSettings} from '../../models/ocl';
import {UrlProviderService} from '../general';

@Injectable({
  providedIn: 'root'
})
export class LabSettingsService {

  constructor(private urlProvider: UrlProviderService, private httpClient: HttpClient) {
  }

  public getSettings() {
    const logoRequest = this.httpClient.get<LabSettings>(`${this.urlProvider.ApiUrl}/system/settings/logo`);
    const licenseRequest = this.httpClient.get<LabSettings>(`${this.urlProvider.ApiUrl}/system/settings/license`);
    const billingRequest = this.httpClient.get<LabSettings>(`${this.urlProvider.ApiUrl}/system/settings/billing`);
    const reportRequest = this.httpClient.get<LabSettings>(`${this.urlProvider.ApiUrl}/system/settings/report`);

    // TODO REPLACE IT'S DEPRECATED
    const observable = forkJoin(logoRequest, billingRequest, reportRequest, licenseRequest);
    return observable.pipe(
      retry(2),
      map(([logoResponse, billingResponse, reportResponse, licenseResponse]) => {
        return {
          logo: logoResponse.logo,
          address: reportResponse.address,
          url: reportResponse.url,
          email: licenseResponse.email,
          name: licenseResponse.name,
          fax: billingResponse.fax,
          phone: billingResponse.phone,
        } as LabSettings;
      })
    );
  }

  public getToxicologySettings() {
    return this.httpClient.get<any>(`${this.urlProvider.ApiUrl}/settings/results`).pipe(retry(2));
  }

  public getWebSupplyCategorySettings() {
    return this.httpClient.get<any>(`${this.urlProvider.ApiUrl}/settings/supply-categories`).pipe(retry(2));
  }

  public getResultEntrySettings() {
    return this.httpClient.get<{
      resultEntryEnabled: boolean,
      resultEntrySuperUser: boolean,
      resultEntryClientAdmin: boolean,
      resultEntryClientBasic: boolean
    }>(`${this.urlProvider.ApiUrl}/system/settings/result-entry`)
      .pipe(retry(2));
  }
}
